import { createUSeDirectBookingStrategy } from "./usedirect.js";

export default createUSeDirectBookingStrategy({
  bookingBaseUrl: "https://azstateparks.com/reserve",
});
